import { render, staticRenderFns } from "./EmergencyRoom.vue?vue&type=template&id=b8a926e6"
import script from "./EmergencyRoom.vue?vue&type=script&lang=js"
export * from "./EmergencyRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports